/* Abajuu v2 favorites: stored only in the visitor's own browser (localStorage). */
(() => {
  const KEY = 'abajuu:favorites';
  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  };
  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (error) {}
    document.dispatchEvent(new CustomEvent('abajuu:favorites-change'));
  };

  if (!window.AbajuuFavorites) {
    window.AbajuuFavorites = {
      read,
      has: (handle) => read().includes(handle),
      toggle(handle) {
        const list = read();
        const index = list.indexOf(handle);
        if (index > -1) {
          list.splice(index, 1);
        } else {
          list.unshift(handle);
        }
        write(list.slice(0, 60));
        return index === -1;
      },
    };
  }

  if (!customElements.get('v2-favorite-button')) {
    customElements.define(
      'v2-favorite-button',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          if (!this.button) return;
          this.button.addEventListener('click', this.onClick);
          document.addEventListener('abajuu:favorites-change', this.update);
          this.update();
        }

        disconnectedCallback() {
          this.button?.removeEventListener('click', this.onClick);
          document.removeEventListener('abajuu:favorites-change', this.update);
        }

        onClick = (event) => {
          event.preventDefault();
          event.stopPropagation();
          window.AbajuuFavorites.toggle(this.dataset.handle);
        };

        update = () => {
          const active = window.AbajuuFavorites.has(this.dataset.handle);
          this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
        };
      }
    );
  }

  const updateCounts = () => {
    const count = read().length;
    document.querySelectorAll('[data-v2-fav-count]').forEach((element) => {
      element.textContent = count;
      element.hidden = count === 0;
    });
  };

  document.addEventListener('abajuu:favorites-change', updateCounts);
  window.addEventListener('storage', (event) => {
    if (event.key === KEY) document.dispatchEvent(new CustomEvent('abajuu:favorites-change'));
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCounts);
  } else {
    updateCounts();
  }
})();
